import React from 'react';
import IconButton from 'components/generics/IconButton';
import Edit from 'components/pages/Home/Edit';
// import Delete from 'components/icons/Delete';

const TypeOrganismTable  = props => (
    <table>
      <thead>
        <tr>
          <th>Type d'organisme</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {props.typeOrganism.length > 0 ? (
          props.typeOrganism.map(item => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td className="actionner">
                <IconButton onClick={() => props.editRow(item)} icon={<Edit  />} />
                {/* <IconButton  onClick={() => props.handleDeleteTypeOrganism(item.id)} icon={<Delete  />} /> */}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3}>Pas de type d'organisme</td>
          </tr>
        )}
      </tbody>
    </table>
  )
  

export default TypeOrganismTable;
